import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';

export const useCurrencies = () => {
  const { data, error, isLoading } = useSWR(swrKeys.meta.currencies());

  return {
    currencies: data ?? [],
    isLoading,
    error,
  };
};
